import { Box, Divider, Typography } from '@mui/material';
import { upperFirst } from 'lodash';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { STRINGS } from '../../../constants';
import {
  NetworkHelpers,
  ParcelHelpers,
  ShipmentHelpers,
} from '../../../helpers';

export const BasketCardHeader = ({
  shipment = {},
  rightCardContent,
  error,
}) => {
  const { networkCode, parcels, _network } = shipment.outboundConsignment || {};
  const receiverContactName = ShipmentHelpers.getReceiverContactName(shipment);
  const parcelsQuantity = ParcelHelpers.getParcelsQuantity(parcels);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          padding: 2,
          flexWrap: 'nowrap',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {error && (
          <Box sx={{ mr: 1 }}>
            <WarningAmberIcon color='error' />
          </Box>
        )}
        <Box sx={{ maxWidth: '100%', mr: { xs: 1, md: 2 }, flexGrow: 1 }}>
          <Box>
            <Typography
              variant='h3'
              component='h2'
              sx={{
                fontSize: '20px',
                fontWeight: 400,
                lineHeight: '24px',
                overflow: 'hidden',
                wordBreak: 'break-word',
              }}
            >
              {upperFirst(
                receiverContactName
                  ? STRINGS.PARCEL_TO_$(receiverContactName, parcelsQuantity)
                  : STRINGS.PARCEL_$(parcelsQuantity)
              )}
            </Typography>
          </Box>
          <Box>
            {networkCode && (
              <Typography
                variant='body2'
                sx={{
                  fontSize: '12px',
                  fontWeight: 370,
                  letterSpacing: '0.17px',
                }}
              >
                {NetworkHelpers.getBasketServiceName(_network)}
              </Typography>
            )}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'end', flexGrow: 1 }}>
          {rightCardContent}
        </Box>
      </Box>
      <Divider />
    </>
  );
};
